import { render, staticRenderFns } from "./BuscaEtapa.vue?vue&type=template&id=7d71be81&"
import script from "./BuscaEtapa.vue?vue&type=script&lang=js&"
export * from "./BuscaEtapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports